module.exports = __webpack_public_path__ + "static/media/Discovery-Scale.41b273f3.svg";